import React, { useState, useEffect } from 'react';
import { Bell, Calendar, ChevronRight, Eye, Inbox } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import Drawer from '../../components/common/Drawer/Drawer';
import api from '../../api/axios';
import styles from './ResidentNotices.module.css';

const ResidentNotices = () => {
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/community/notices');
      setNotices(data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch notices:', error);
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <PageHeader 
        title="Society Notices" 
        breadcrumb={['Community', 'Notices']} 
      />

      <div className={styles.grid}>
        {loading ? <p>Loading notices...</p> : notices.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '4rem 2rem', background: '#fff', borderRadius: '12px', border: '1px dashed #d1d5db', gridColumn: '1 / -1' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '64px', height: '64px', borderRadius: '50%', background: '#f0fdf4', color: '#154530', marginBottom: '1rem' }}>
              <Inbox size={32} />
            </div>
            <h3 style={{ margin: '0 0 0.5rem 0', color: '#111', fontSize: '18px' }}>No Notices Available</h3>
            <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>There are currently no active notices or announcements from the society management.</p>
          </div>
        ) : notices.map(notice => (
          <div key={notice._id} className={styles.card} onClick={() => setSelectedNotice(notice)}>
            <div className={styles.cardHeader}>
              <div style={{ display: 'flex', gap: '8px' }}>
                <span className={styles.badgeCategory}>{notice.category}</span>
                {notice.targetAudience === 'Resident' && (
                  <span className={styles.badgeCategory} style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>Residents Only</span>
                )}
              </div>
              <span className={styles.date}><Calendar size={12} /> {notice.date}</span>
            </div>
            <div className={styles.cardBody}>
              <h3>{notice.title}</h3>
              <p>{notice.content.substring(0, 80)}...</p>
              {(notice.meetingDateTime || notice.meetingLocation) && (
                <div style={{ fontSize: '12px', color: '#4b5563', marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {notice.meetingDateTime && <span><strong>Time:</strong> {new Date(notice.meetingDateTime).toLocaleString()}</span>}
                  {notice.meetingLocation && <span><strong>Place:</strong> {notice.meetingLocation}</span>}
                </div>
              )}
            </div>
            <div className={styles.cardFooter}>
              <span className={styles.readMore}>
                <Eye size={14} /> Read Full Notice
              </span>
              <ChevronRight size={16} className={styles.iconRight} />
            </div>
          </div>
        ))}
      </div>

      <Drawer 
        isOpen={!!selectedNotice} 
        onClose={() => setSelectedNotice(null)} 
        title="Notice Details"
      >
        {selectedNotice && (
          <div className={styles.noticeDetail}>
            <div className={styles.detailMeta}>
              <span className={styles.badgeCategory}>{selectedNotice.category}</span>
              <span className={styles.date}><Calendar size={14} /> {selectedNotice.date}</span>
            </div>
            <h2 className={styles.detailTitle}>{selectedNotice.title}</h2>
            {(selectedNotice.meetingDateTime || selectedNotice.meetingLocation) && (
              <div style={{ marginTop: '1rem', marginBottom: '1rem', padding: '1rem', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                {selectedNotice.meetingDateTime && (
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem', gap: '8px', color: '#334155' }}>
                    <strong>Date & Time:</strong> {new Date(selectedNotice.meetingDateTime).toLocaleString()}
                  </div>
                )}
                {selectedNotice.meetingLocation && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#334155' }}>
                    <strong>Location:</strong> {selectedNotice.meetingLocation}
                  </div>
                )}
              </div>
            )}
            <div className={styles.detailContent}>
              <p>{selectedNotice.content}</p>
            </div>
            
            <div className="formActions">
              <button type="button" className="btnCancel" onClick={() => setSelectedNotice(null)}>Close</button>
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
};

export default ResidentNotices;
